import React from "react";
import TicketCard from "./TicketCard";

/**
 * TicketCardView - Card grid layout for ticket items
 * 
 * Displays tickets in a responsive card grid instead of a table.
 * Uses the same data and column configuration as TicketLogTable.
 * 
 * @param {Object} props
 * @param {Array} props.data - Array of ticket objects to display
 * @param {Array} props.columns - Column configuration (used for card content)
 * @param {React.Component} props.CardComponent - Custom card component (optional)
 * @param {Function} props.onCardClick - Callback when a card is clicked
 * @param {string} props.emptyMessage - Message when no items found
 * @param {Object} props.cardProps - Additional props passed to CardComponent
 * @returns {JSX.Element}
 */
const TicketCardView = ({
  data = [],
  columns = [],
  CardComponent = TicketCard,
  onCardClick,
  emptyMessage = "No items found",
  cardProps = {},
}) => {
  if (data.length === 0) {
    return (
      <div className="p-8 text-center text-gray-500">
        <i>{emptyMessage}</i>
      </div>
    );
  }

  return (
    <div className="p-4 flex flex-col gap-3">
      {data.map((item) => (
        <CardComponent
          key={item.id}
          item={item}
          columns={columns}
          onCardClick={onCardClick}
          {...cardProps}
        />
      ))}
    </div>
  );
};

export default TicketCardView;
